export const SEPARATOR = '$::$';

export const getReactKeyFromFilterOption = (id: string, desc: string): string =>
  `${id}${SEPARATOR}${desc}`;

export const getFilterIdFromReactKey = (key: string): string | undefined =>
  key.split(SEPARATOR)[0];
